/**
 * WARNING: This file is auto-generated. Please do not modify it.
 *
 * If you need to make changes, please see the README.md file in the root of this repository.
 */

import { AxiosRequestConfig, AxiosResponse } from 'axios';

import { Controller } from '../Controller';

import {
  GetV2ProjectsByProjectIdParams,
  PutV2ProjectsByProjectIdParams,
  DeleteV2ProjectsByProjectIdParams,
  PostV2ProjectsUsersInvitationsByProjectIdParams,
  PostV2ProjectsRecoverByProjectIdParams,
  GetV2ProjectsUsersByProjectIdParams,
  GetV2ProjectsUsersInvitationsRolesByProjectIdParams,
  PostV2ProjectsUsersInvitationsAcceptQuery,
  PutV2ProjectsByProjectIdBody,
  PostV2ProjectsBody,
  PostV2ProjectsUsersInvitationsByProjectIdBody,
  DeleteV2ProjectsRolesBody,
  GetV2ProjectsByProjectIdResponse,
  PutV2ProjectsByProjectIdResponse,
  PostV2ProjectsResponse,
  PostV2ProjectsUsersInvitationsAcceptResponse,
  GetV2ProjectsUsersByProjectIdResponse,
  GetV2ProjectsUsersInvitationsRolesByProjectIdResponse,
} from '../types';

export class Projects extends Controller {
  async getV2ProjectsByProjectId<
    T extends GetV2ProjectsByProjectIdResponse,
    D,
    C
  >(
    { projectId }: GetV2ProjectsByProjectIdParams,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.get<T, AxiosResponse<T, D>, C>(
      `/v2/projects/${projectId}`,
      axiosConfig
    );
  }

  async putV2ProjectsByProjectId<
    T extends PutV2ProjectsByProjectIdResponse,
    D,
    C extends PutV2ProjectsByProjectIdBody
  >(
    body: C,
    { projectId }: PutV2ProjectsByProjectIdParams,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.put<T, AxiosResponse<T, D>, C>(
      `/v2/projects/${projectId}`,
      body,
      axiosConfig
    );
  }

  async deleteV2ProjectsByProjectId<T, D, C extends null>(
    { projectId }: DeleteV2ProjectsByProjectIdParams,
    axiosConfig?: AxiosRequestConfig<C> | undefined,
    body?: C
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.delete<T, AxiosResponse<T, D>, C>(
      `/v2/projects/${projectId}`,
      { ...axiosConfig, data: body }
    );
  }

  async postV2Projects<
    T extends PostV2ProjectsResponse,
    D,
    C extends PostV2ProjectsBody
  >(
    body: C,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.post<T, AxiosResponse<T, D>, C>(
      '/v2/projects',
      body,
      axiosConfig
    );
  }

  async postV2ProjectsUsersInvitationsByProjectId<
    T,
    D,
    C extends PostV2ProjectsUsersInvitationsByProjectIdBody
  >(
    body: C,
    { projectId }: PostV2ProjectsUsersInvitationsByProjectIdParams,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.post<T, AxiosResponse<T, D>, C>(
      `/v2/projects/${projectId}/users/invitations`,
      body,
      axiosConfig
    );
  }

  async postV2ProjectsRecoverByProjectId<T, D, C extends null>(
    body: C,
    { projectId }: PostV2ProjectsRecoverByProjectIdParams,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.post<T, AxiosResponse<T, D>, C>(
      `/v2/projects/${projectId}/recover`,
      body,
      axiosConfig
    );
  }

  async postV2ProjectsUsersInvitationsAccept<
    T extends PostV2ProjectsUsersInvitationsAcceptResponse,
    D,
    C extends null
  >(
    body: C,
    query: PostV2ProjectsUsersInvitationsAcceptQuery,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.post<T, AxiosResponse<T, D>, C>(
      this.composeUrl('/v2/projects/users/invitations/accept', query),
      body,
      axiosConfig
    );
  }

  async getV2ProjectsUsersByProjectId<
    T extends GetV2ProjectsUsersByProjectIdResponse,
    D,
    C
  >(
    { projectId }: GetV2ProjectsUsersByProjectIdParams,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.get<T, AxiosResponse<T, D>, C>(
      `/v2/projects/${projectId}/users`,
      axiosConfig
    );
  }

  async getV2ProjectsUsersInvitationsRolesByProjectId<
    T extends GetV2ProjectsUsersInvitationsRolesByProjectIdResponse,
    D,
    C
  >(
    { projectId }: GetV2ProjectsUsersInvitationsRolesByProjectIdParams,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.get<T, AxiosResponse<T, D>, C>(
      `/v2/projects/${projectId}/users/invitations/roles`,
      axiosConfig
    );
  }

  async deleteV2ProjectsRoles<T, D, C extends DeleteV2ProjectsRolesBody>(
    axiosConfig?: AxiosRequestConfig<C> | undefined,
    body?: C
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.delete<T, AxiosResponse<T, D>, C>(
      '/v2/projects/roles',
      { ...axiosConfig, data: body }
    );
  }
}
